import { render, staticRenderFns } from "./learner-facets-proficiency.vue?vue&type=template&id=68f3b2ba&scoped=true"
import script from "./learner-facets-proficiency.ts?vue&type=script&lang=ts&external"
export * from "./learner-facets-proficiency.ts?vue&type=script&lang=ts&external"
import style0 from "./learner-facets-proficiency.scss?vue&type=style&index=0&id=68f3b2ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f3b2ba",
  null
  
)

export default component.exports